import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMp3ConverterConfig } from '@/data/landingConfig/landingMp3ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Mp3Converter } from './schemaObject';

interface Props {}
const Mp3Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_Mp3Converter} />
			<VideoLandingTemplate
				data={landingMp3ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default Mp3Converter;
